import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
  `,
  content: css`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    overflow: hidden;
  `,
  header: css`
    display: flex;
    width: 100%;
    align-items: center;
    height: 64px;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
